/// <amd-module name="WidgetCommon/WitUtils/Constants" />
/*
 * These constants were copied from vss-work-web/work-items-hub
 */

export namespace CoreFieldRefNames {
    export let Id = "System.Id";
    export let Title = "System.Title";
    export let WorkItemType = "System.WorkItemType";
}

export namespace ActionUrl {
    export const ACTION = "action";
    export const ACTION_QUERY = "query";
    export const ACTION_EDIT = "edit";
}

export namespace ActionParameters {
    export const TEMPQUERYID = "tempQueryId";
    export const PATH = "path";
    export const ID = "id";
}

export enum WorkItemStateCategory {
    Proposed = 1000,
    InProgress = 2000,
    Resolved = 3000,
    Completed = 4000,
    Removed = 5000
}
